import React from 'react';

const PrivacyPolicyMarkdownConverter = () => {
  const containerStyle = {
    padding: '20px',
    marginTop: '60px',
    maxWidth: '800px',
    marginLeft: 'auto',
    marginRight: 'auto',
    fontFamily: 'Arial, sans-serif',
    lineHeight: '1.6',
    backgroundColor: '#ffffff',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
  };

  const headerStyle = {
    color: '#111',
  };

  const paragraphStyle = {
    color: '#333',
  };

  const linkStyle = {
    color: '#007BFF',
    textDecoration: 'none',
  };

  return (
    <div style={containerStyle}>
      <h1 style={headerStyle}>Privacy Policy</h1>
      <p style={paragraphStyle}><strong>Effective Date:</strong> 04.09.2026</p>

      <p style={paragraphStyle}>At Markdown Converter, we respect your privacy and are committed to protecting your personal information. This Privacy Policy explains how the Chrome extension handles data when you use it.</p>

      <h2 style={headerStyle}>1. Data Collection</h2>
      <p style={paragraphStyle}>Markdown Converter converts the active web page or your selected text into Markdown. Conversion runs entirely inside your browser. We do not operate servers for this extension, we do not require an account, and we do not collect, upload, store, or transmit page content, selections, converted Markdown, page URLs, or browsing history.</p>

      <h3 style={headerStyle}>Optional, anonymous usage statistics</h3>
      <p style={paragraphStyle}>The extension can send anonymous usage statistics to help improve it. This is <strong>disabled by default</strong> and only active after you enable it in the extension settings ("Privacy" section). When enabled, the extension sends:</p>
      <ul>
        <li style={paragraphStyle}>Event names describing actions (for example: popup_opened, convert, copy, download, open_view, context_menu)</li>
        <li style={paragraphStyle}>Non-identifying parameters such as the conversion mode or output format</li>
        <li style={paragraphStyle}>A random identifier generated on your device (not linked to your identity or account)</li>
        <li style={paragraphStyle}>Technical metadata processed by Google Analytics (for example IP address and browser information)</li>
      </ul>
      <p style={paragraphStyle}>We never send page content, your text selections, converted Markdown, page URLs, or browsing history — regardless of whether statistics are enabled.</p>

      <h2 style={headerStyle}>2. Local Processing and Storage</h2>
      <p style={paragraphStyle}>When you run a conversion, page or selection content is read only on your device so it can be turned into Markdown. That content stays in the extension UI (popup or viewer) until you copy, download, or close it.</p>
      <p style={paragraphStyle}>Preferences you choose (such as conversion mode, language, output options, auto-copy, and the analytics consent) are saved locally in your browser with Chrome storage. You can clear them by removing the extension or clearing extension data in Chrome.</p>

      <h2 style={headerStyle}>3. Third-Party Processing (Google Analytics)</h2>
      <p style={paragraphStyle}>When statistics are enabled, data is sent to Google Analytics 4, operated by Google. Google processes this data under its own terms:</p>
      <ul>
        <li style={paragraphStyle}><a style={linkStyle} href="https://marketingplatform.google.com/about/analytics/terms/" target="_blank" rel="noopener noreferrer">Google Analytics Terms of Service</a></li>
        <li style={paragraphStyle}><a style={linkStyle} href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google Privacy Policy</a></li>
      </ul>
      <p style={paragraphStyle}>Google may retain analytics data for up to 14 months, in line with this property's retention setting. We do not sell or share this data with anyone else, and we do not use it for advertising.</p>

      <h2 style={headerStyle}>4. Permissions</h2>
      <p style={paragraphStyle}>The extension requests only the permissions needed for its single purpose — converting page or selection content into Markdown:</p>
      <ul>
        <li style={paragraphStyle}><strong>activeTab:</strong> Read the current tab when you click the extension or use the keyboard shortcut.</li>
        <li style={paragraphStyle}><strong>scripting:</strong> Inject content scripts on that tab to extract and convert content.</li>
        <li style={paragraphStyle}><strong>storage:</strong> Save your preferences locally in the browser.</li>
        <li style={paragraphStyle}><strong>contextMenus:</strong> Add right-click actions to convert a page or selection.</li>
        <li style={paragraphStyle}><strong>downloads:</strong> Save converted output as a file (for example .md, .txt, .html) when you choose to download it.</li>
        <li style={paragraphStyle}><strong>https://www.google-analytics.com/*:</strong> Send the optional, anonymous usage statistics — only if you enabled them.</li>
      </ul>
      <p style={paragraphStyle}>The extension does not request permanent host access to websites. It accesses a page only when you invoke it.</p>

      <h2 style={headerStyle}>5. Your Choices and Rights (GDPR)</h2>
      <p style={paragraphStyle}>For users in the EU/EEA, usage statistics are collected only on the basis of your consent (Article 6(1)(a) GDPR). You can:</p>
      <ul>
        <li style={paragraphStyle}><strong>Withdraw consent at any time</strong> by turning off the statistics toggle in the extension settings. After withdrawal, no further data is sent.</li>
        <li style={paragraphStyle}><strong>Request access to or deletion of your data</strong> by contacting us at the email below. Analytics identifiers are random and not linked to your identity, but we can help with deletion requests where technically possible.</li>
        <li style={paragraphStyle}><strong>Lodge a complaint</strong> with your local data protection authority.</li>
      </ul>

      <h2 style={headerStyle}>6. Data Security</h2>
      <p style={paragraphStyle}>Conversion and preference storage happen locally in your browser. Optional statistics are transmitted over encrypted HTTPS connections to Google. You remain responsible for how you copy, download, or share converted files.</p>

      <h2 style={headerStyle}>7. Changes to this Policy</h2>
      <p style={paragraphStyle}>We may update this Privacy Policy from time to time. Significant changes will be communicated through the Chrome Web Store listing or our website.</p>

      <h2 style={headerStyle}>8. Contact Us</h2>
      <p style={paragraphStyle}>If you have any questions about this Privacy Policy, please contact us at <a style={linkStyle} href="mailto:mehmetalicelebii@gmail.com">mehmetalicelebii@gmail.com</a>.</p>
    </div>
  );
};

export default PrivacyPolicyMarkdownConverter;